import Model from '@/models/Model'

export default class AReception extends Model {
    resource() {
        return 'reception'
    }
}